import classNames from 'classnames';
import { Link } from 'react-router-dom';
import styles from '~/components/Header/Header.module.scss';
import { Logo } from '~/components/Icon';

export type IsolatedHeaderProps = {
  className?: string;
};

export const IsolatedHeader = ({ className }: IsolatedHeaderProps) => (
  <div className={classNames(styles.root, className, 'header')}>
    <div className={styles.inner}>
      <Link to="/" data-event="click" data-event-target="gnb_logo">
        <Logo className={styles.logo} display="block" />
      </Link>
    </div>
  </div>
);
